import React from 'react';
import Toolbar from '@mui/material/Toolbar';
import { CreateButton } from 'react-admin';
import {
  List,
  Edit,
  Create,
  Datagrid,
  TextField,
  SimpleForm,
  TextInput,
  EditButton,
  ReferenceInput,
  ReferenceArrayInput,
  SelectArrayInput,
  AutocompleteInput,
  DateInput,
  Filter,
  BooleanInput,
  SelectInput,
  required
} from 'react-admin';
import { RichTextInput, RichTextInputToolbar, FormatButtons, ListButtons, LinkButtons } from 'ra-input-rich-text';

const TextFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Тэтгэлэгийн нэр" source="name" alwaysOn />
  </Filter>
);

const Action = props => {
  const {
    filters,
    showFilter,
    resource,
    displayedFilters,
    filterValues,
    basePath,
  } = props

  return (
    <Toolbar>
      {filters &&
        React.cloneElement(filters, {
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: 'button',
        })}
      <CreateButton basePath={basePath} />
    </Toolbar>
  );
};

export const ScholarshipList = (props) => (
  <List {...props} filters={<TextFilter/>} actions={<Action props={props} />}>
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <TextField label="Тэтгэлэгийн нэр" source="name" />
      <TextField label="Боловсролын зэрэг" source="degree" />
      <TextField source="tags" />
      <EditButton />
    </Datagrid>
  </List>
);

export const ScholarshipEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <BooleanInput label="Notification явуулах уу?" source="shouldSendNotification" initialValue={false} />
      <TextInput source="id" readOnly />
      <TextInput fullWidth multiline source="picture" />
      <TextInput multiline fullWidth rows={3} source="name" />
      <ReferenceInput label="Service provider" source="providerId" reference="contentProviders" perPage={100}>
        <AutocompleteInput source="providerId" optionText="name" />
      </ReferenceInput>
      <TextInput source="degree" />
      <ReferenceInput label="Хэл (tag)" source="tagging.languageId" reference="languages">
        <SelectInput source="tagging.languageId" optionText="name" validate={[required()]} />
      </ReferenceInput>
      <ReferenceArrayInput source="tagging.countryIds" label="Харгалзах улсууд (tag)" reference="countries">
        <SelectArrayInput source="tagging.countryIds" optionText="name" validate={[required()]} />
      </ReferenceArrayInput>
      <ReferenceArrayInput label="Tag" source="tags" reference="tags" perPage={500}>
        <SelectArrayInput source="tags" optionText="name" optionValue="name" />
      </ReferenceArrayInput>
      <RichTextInput source="coverage" toolbar={<RichTextInputToolbar><FormatButtons /><ListButtons /><LinkButtons /></RichTextInputToolbar>}  />
      <RichTextInput source="description" toolbar={<RichTextInputToolbar><FormatButtons /><ListButtons /><LinkButtons /></RichTextInputToolbar>} />
      <RichTextInput source="requirement" toolbar={<RichTextInputToolbar><FormatButtons /><ListButtons /><LinkButtons /></RichTextInputToolbar>} />
      <DateInput source="deadline" />
      <TextInput fullWidth source="link" />
    </SimpleForm>
  </Edit>
);

export const ScholarshipCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <BooleanInput label="Notification явуулах уу?" source="shouldSendNotification" initialValue={true} />
      <TextInput source="id" readOnly />
      <TextInput fullWidth multiline source="picture" />
      <TextInput multiline fullWidth rows={3} source="name" />
      <ReferenceInput label="Service provider" source="providerId" reference="contentProviders" perPage={100}>
        <AutocompleteInput source="providerId" optionText="name" />
      </ReferenceInput>
      <TextInput source="degree" />
      <ReferenceInput label="Хэл (tag)" source="tagging.languageId" reference="languages">
        <SelectInput source="tagging.languageId" optionText="name" validate={[required()]} />
      </ReferenceInput>
      <ReferenceArrayInput source="tagging.countryIds" label="Харгалзах улсууд (tag)" reference="countries">
        <SelectArrayInput source="tagging.countryIds" optionText="name" validate={[required()]} />
      </ReferenceArrayInput>
      <ReferenceArrayInput label="Tag" source="tags" reference="tags" perPage={500}>
        <SelectArrayInput source="tags" optionText="name" optionValue="name" />
      </ReferenceArrayInput>
      <RichTextInput source="coverage" toolbar={<RichTextInputToolbar><FormatButtons /><ListButtons /><LinkButtons /></RichTextInputToolbar>} />
      <RichTextInput source="description" toolbar={<RichTextInputToolbar><FormatButtons /><ListButtons /><LinkButtons /></RichTextInputToolbar>} />
      <RichTextInput source="requirement" toolbar={<RichTextInputToolbar><FormatButtons /><ListButtons /><LinkButtons /></RichTextInputToolbar>} />
      <DateInput source="deadline" />
      <TextInput fullWidth source="link" />
    </SimpleForm>
  </Create>
);
